// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Container from '../components/Question/Overview/Container';
import Login from '../components/User/Login/Login';

@inject('modalStore', 'messageStore')
@observer class HomeRoute extends Component<any, any> {

	componentDidMount() {
		const urlParams = new URLSearchParams(
            window.location.search.substring(1)
        );
        const login = urlParams.get('login');
        if (login) {
            this.loginNotice();
        }
	}

	loginNotice() {
        this.props.modalStore.createModal('Login', <Login />);
        
        this.props.messageStore.setMessage(
            'error',
            'you have to be logged in.',
            2000
        );
        window.history.replaceState({}, document.title, '/');
    }


	render() {
		return (
			<Container />
		)
	}
}

export default HomeRoute;

